import axios from "axios";
import baseURL from "../configs/api";

export const post_QuoteAdditionalCharge = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}quoteAdditionalCharge`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            userId
        }
    });
    return response.data;
}

export const getQuoteAdditionalChargesByQuoteId = (quoteId: number, tenantId: string) => {
    return getFetch(`quoteAdditionalCharge/GetQuoteAdditionalChargesForQuote/${quoteId}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}